/** Role values from API may vary; normalize before checks. */
function normalizeRole(user) {
  const raw =
    user?.role ??
    user?.user_role ??
    user?.type ??
    user?.role_name ??
    "";
  return String(raw).trim().toLowerCase().replace(/\s+/g, " ");
}

function slugifyRole(user) {
  return normalizeRole(user).replace(/\s+/g, "_");
}

/** Super Admin sees the full sidebar below the header; others only see Projects. */
export function isSuperAdmin(user) {
  const spaced = normalizeRole(user);
  const slug = slugifyRole(user);
  const superFlag = user?.is_superadmin ?? user?.isSuperadmin;
  const isFlagEnabled =
    superFlag === true ||
    superFlag === 1 ||
    String(superFlag).toLowerCase() === "1" ||
    String(superFlag).toLowerCase() === "true";

  if (isFlagEnabled) {
    return true;
  }

  return (
    spaced === "super admin" ||
    slug === "super_admin" ||
    slug === "superadmin"
  );
}

/** Short label shown in sidebar role badge when not mapped elsewhere. */
export function getRoleBadgeLabel(user) {
  const raw =
    user?.role ?? user?.user_role ?? user?.type ?? user?.role_name ?? "";
  const s = String(raw).trim();
  if (!s) return "Member";
  if (isSuperAdmin(user)) return "Super Admin";
  return s;
}
